import { useCountdownTimer } from 'hooks/useCountdownTimer';
import React, { useEffect, useState } from 'react';

const Timer = React.memo(
  ({ endTime, onTimeEnd }: { endTime: string; onTimeEnd: () => void }) => {
    const [isTimeEnd, setIsTimeEnd] = useState(false);

    const { hours, minutes, seconds } = useCountdownTimer(endTime);

    useEffect(() => {
      if (
        endTime &&
        hours === '00' &&
        minutes === '00' &&
        seconds === '00' &&
        !isTimeEnd
      ) {
        onTimeEnd();
        setIsTimeEnd(true);
      }
    }, [hours, minutes, seconds, isTimeEnd]);
    if (!(hours && minutes && seconds)) return null;
    return (
      <div className="fs-5">
        {hours}:{minutes}:{seconds}
      </div>
    );
  }
);

export default Timer;
